/* tslint:disable */
/* eslint-disable */
import { BaseModel } from '@/core/models/base.model';
import { FormGroup, FormControl, FormArray, AbstractControl, Validators } from '@angular/forms';

// All imports for FormGroups..

export interface IResetPasswordCommand {
  password?: null | string;
  verificationToken?: null | string;
}
export class ResetPasswordCommand extends BaseModel implements IResetPasswordCommand {
  password?: null | string;
  verificationToken?: null | string;
}

